export const BACKEND_PATH = "";

export const FILE_PATH = "https://aethenos.com:2053/aethenos-assert/"
// export const FILE_PATH = "https://api-aethenos.exonsoftware.lk/aethenos-assert/"
// export const FILE_PATH = "http://localhost:8082/aethenos-assert/"

// https://aethenosinstructor.exon.lk:2053/aethenos-assert/
// http://185.209.223.202:8080/aethenos-assert/